import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '../services/navigation/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectAuthenticatedGuard implements CanActivate {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly navigationService: NavigationService,
  ) {}

  async canActivate(): Promise<boolean> {
    if (this.authenticationService.permissions.length) {
      const firstVisibleItem = this.navigationService.getFirstVisibleItem(false);
      if (firstVisibleItem) {
        location.href = firstVisibleItem.url;
        return false;
      }
    }

    return true;
  }
}

